module.exports = __webpack_public_path__ + "button-arrow-prev.svg?66e028003e690b9b3a7ecf4dfb664f1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-arrow-prev.svg
// module id = 51
// module chunks = 0